import React, { Component } from 'react';
import './VumaSuccessScreen.css';
import { SalesContext } from '../../Context/SalesContext';
import SuccessIcon from '../Common/Svg/SuccessIcon';
import NetworkIcon from '../Common/Svg/NetworkIcon';
import ToolsIcon from '../Common/Svg/ToolsIcon';
import QuoteIcon from '../Common/Svg/QuoteIcon';
import { tagOnVumatelSuccessPageLoad } from '../../Tagging/VumareachTagging';
import { getHashInteger } from './../../Utility/utility';

class SuccessScreen extends Component {
	static contextType = SalesContext;

	componentDidMount() {
		if (this.context.selectedPackage === null) {
			this.props.history.push('/cloud/fibre/sales/choosePlan');
			return;
		}
		let userId = this.context.employmentDetails.selectedIdTab === 'idNumber' ? this.context.employmentDetails.idNumber : this.context.employmentDetails.passportNumber;
		userId = getHashInteger(userId);
		tagOnVumatelSuccessPageLoad(userId, this.context.selectedPackage.provider + ' - ' + this.context.selectedPackage.description, this.context.selectedVumaProduct.price);
	}

	componentWillUnmount() {
		this.context.setSelectedPackage(null);
		this.context.setVumaContactDetails({
			firstName: '',
			lastName: '',
			email: '',
			cellPhone: ''
		});
		this.context.setEmploymentDetails({
			employmentType: "",
			employerName: "",
			passportIssueCountry: "",
			idNumber: "",
			passportNumber: "",
			dateOfExpiry: "",
			cellPhoneNo: "",
			selectedIdTab: "idNumber"
		})
		window.location.href = "/vodacom/fibre/sales/leads";
	}

	successBtnClickHandler = () => {
		window.location.href = "/vodacom/fibre/sales/leads";
	}

	render() {
		return (
			<div className="success-wrapper">
				<div className="success-name-container">
					<div className="icon-wrapper"><div className="successIcon-size" automationid={`SalesLead_Div_SuccessIcon_0`}><SuccessIcon /></div></div>
					<div
						className="text-name success-bold-font"
						automationid={`SalesLead_Div_ThanksMsg_0`}
					>
						Thanks, {this.context.userDetails.firstName}.
					</div>
					<div className="text-name success-bold-font text-name-order" automationid={`SalesLead_Div_WeReceivedOrder_2`}>We've received your order!</div>
				</div>

				<div className="success-email-container">
					<div className="success-email-item">
						<div
							className="text-padding text-font-mobile text-padding-tablet success-regular-font"
							automationid={`SalesLead_Div_ConfirmationMailSentTo_0`}
						>
							A confirmation  email has been sent to:
						</div>
						<div
							className="textAlign-left text-color-mobile success-regular-font"
							automationid={`SalesLead_Div_EmailSentTo_0`}
						>
							{this.context.userDetails.email}
						</div>
					</div>
				</div>

				<div>
					<div
						className="text-name text-font text-font-tablet  success-bold-font"
						automationid={`SalesLead_Div_WhatHappensNextText_0`}
					>
						What happens next...
					</div>
					<div className="success-container">
						<div className="success-item">
							<div className="icon-padding"><QuoteIcon /></div>
							<div
								className="text-padding-heading success-bold-font"
								automationid={`SalesLead_Div_QuotationHeading_0`}
							>
								1. Payment
									</div>
							<div
								className="text-content-size text-padding-content success-light-font"
								automationid={`SalesLead_Div_QuotationDesc_0`}
							>
								You will receive an email confirming your order. Please follow the instructions within the email to complete your purchase via PayFast or EasyPay.
									</div>
						</div>
						<div className="success-item">
							<div className="icon-padding"><ToolsIcon /></div>
							<div
								className="text-padding-heading success-bold-font"
								automationid={`SalesLead_Div_InstallationHeading_0`}
							>
								2. Installation
									</div>
							<div
								className="text-content-size text-padding-content success-light-font"
								automationid={`SalesLead_Div_InstallationDesc_0`}
							>
								If you do not have a Vuma Fibre Reach router in your home, Vuma will be in contact with you shortly to arrange delivery and installation.
									</div>
						</div>
						<div className="success-item">
							<div className="icon-padding"><NetworkIcon /></div>
							<div
								className="text-padding-heading success-bold-font"
								automationid={`SalesLead_Div_ActivationHeading_0`}
							>
								3. Activation
									</div>
							<div
								className="text-content-size text-padding-content success-light-font"
								automationid={`SalesLead_Div_ActivationDesc_0`}
							>
								Once you have completed payment and your Vuma Fibre Reach router is installed, your service will be ready for use.
									</div>
						</div>
					</div>
				</div>
				<div>
					<div className="button-container">
						<button automationid={`SalesLead_Button_GotoHomePage_0`} onClick={this.successBtnClickHandler} className="success-button">GO TO HOME PAGE</button>
					</div>
				</div>
			</div >
		);
	}
}

export default SuccessScreen;